import { render, staticRenderFns } from "./Done.vue?vue&type=template&id=08b06941&scoped=true"
import script from "./Done.vue?vue&type=script&lang=js"
export * from "./Done.vue?vue&type=script&lang=js"
import style0 from "./Done.vue?vue&type=style&index=0&id=08b06941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b06941",
  null
  
)

export default component.exports